import React, { Component, PureComponent } from "react";
import { Button, Input, Tooltip } from "reactstrap";
import LoadingSpinner from './LoadingSpinner'
import { connect } from 'react-redux'
import {
    Card,
    CardText,
    CardBody,
    CardTitle,
    CardSubtitle,
    CardHeader,
    CardDeck,
    CardImg,
    CardColumns
  } from "reactstrap";
  
  import {filterByQuery} from './PoetsReducer';
  import {loadDataAction} from './TimelineReducer';

class PoetsList extends React.Component {
    constructor() {
      super();
      this.filterByQuery = this.filterByQuery.bind(this);
      this.filterTags = this.filterTags.bind(this);
      this.colourSearch = this.colourSearch.bind(this);
      this.renderData = this.renderData.bind(this);
    }
  
    componentDidMount() {
      if(this.props.events === null || this.props.events === undefined) {
        this.props.dispatch(loadDataAction());
      }
    }

    
    filterByQuery(event) {
      var query = event.target.value;
      // this.setState({ query: query });
      this.props.dispatch(filterByQuery(query));
    }
  
    filterTags() {
      const filteredTags = this.props.tags;
      const query = this.props.query;
      if (query === undefined || query === "") {
        return filteredTags;
      }
  
      return filteredTags.filter(tag => {
        return (
          tag.name.indexOf(query) !== -1 || tag.description.indexOf(query) !== -1
        );
      });
    }
  
    colourSearch(text) {
      return text.replace(
        this.props.query,
        "<span style='background-color:yellow'>$&</span>"
      );
    }
  
    render() {
        if(this.props.loading) {
          return <LoadingSpinner visible={true}/>;
        }
    
        return this.renderData();
      }
    
    renderData() {
      const filteredTags = this.filterTags();
      return (
        <div>
          <div className="input-group mb-3">
            <input
              type="text"
              className="form-control"
              placeholder="بحث في الشخصيات"
              onChange={this.filterByQuery}
              value={this.props.query}
            />
          </div>
          <CardColumns>
            {filteredTags.map(a => (
              <Card>
                <CardHeader
                  tag="h4"
                  className="text-center"
                  style={{ backgroundColor: "#E0E0E0" }}
                >
                  <span
                    dangerouslySetInnerHTML={{
                      __html: this.colourSearch(a.name)
                    }}
                  />
                </CardHeader>
                <CardBody className="text-right">
                  <CardText>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: this.colourSearch(a.description)
                      }}
                    />
                  </CardText>
                  عدد الأحداث : {a.totalEvents}
                </CardBody>
              </Card>
            ))}
          </CardColumns>
        </div>
      );
    }
  }
  
  function mapStateToProps(state) {
    return {...state.timeline, ...state.poets};
  }
  
  export default connect(mapStateToProps)(PoetsList);


// WEBPACK FOOTER //
// ./src/PoetsList.js